import { PrimeIcons } from "@primevue/core/api";
import { ApiService } from "./api.service";
import moment from "moment";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";
export default class emailTemplate extends ApiService {
  namespace = "email-template";
  icon = "EMail";
  name = "Type";
  favicon = "MailWithTable";
  template = "defaultTemplate";
  relations = "";
  singular = this.terminology.emailTemplate.singular;
  plural = this.terminology.emailTemplate.plural;
  vowel = this.terminology.emailTemplate.vowel;
  name = `${this.vowel} ${this.singular}`;
  Width = 900;
  DOMAIN = DOMAIN.EMAIL_TEMPLATE;
  action = "actionPreview";
  navItems = [
    {
      key: "active",
      label: this.t("viewActiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.ENABLED,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.DISABLE,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },

  ];
  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: this.singular }),
      icon: AppIcons.PLUS,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.LIST,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.TAG,
      field: "display_name",
    },
    {
      header: this.t("subject"),
      icon: AppIcons.TAG,
      field: "subject",
    },

    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      template: (data) => {
        return moment.unix(data.created_at).format("MM/DD/YYYY");
      },
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Email Template",
      icon: AppIcons.LIST,
    },
  ];
  // filterItems = [];
  getActionMenu(item) {
    let listMenuItems = [
      {
        key: "edit",
        label: "Edit an Employee",
        icon: AppIcons.EDIT,
      },
      {
        key: "status",
        label: 1 == item.status ? "inactiveThisEntity" : "activeThisEntity",
        icon: 1 == item.status ? AppIcons.DISABLE : AppIcons.ENABLED,
      },
    ];
    return listMenuItems;
  }
  constructor() {
    super("email-templates");
  }
}
